import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { I18nextProvider } from 'react-i18next'
import { AuthProvider } from './lib/auth'
import { i18n } from './lib/i18n'
import { queryClient } from './lib/query'
import { ThemeProvider } from './lib/theme'
import { Router } from './router'
import { PreferencesBar } from './components/PreferencesBar'
import './styles/index.css'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root is missing from index.html')
}

createRoot(rootEl).render(
  <React.StrictMode>
    <ThemeProvider>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <Router />
            <PreferencesBar />
          </AuthProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
